import { AbstractControlState, FormState, setUserDefinedProperty } from "ngrx-forms";

export function initIsOptional(value: boolean = true): <TValue>(state: AbstractControlState<TValue>) => FormState<TValue> {
    return setUserDefinedProperty('isOptional', value)
}

export function setIsOptional<TValue>(control: AbstractControlState<TValue>, value: boolean = true) {
    return setUserDefinedProperty(control, "isOptional", value);
}